import { call, query } from "./calls";

export const PackagedAppVersion = {
    list: (appId) => query(`SELECT PackagedAppVersion.id as id, appId, versionName, versionNumber, published, publishedDate, FROM PackagedAppVersion WHERE appId = ${appId} order by versionNumber desc`),
    create: (body) => call('/PackagedAppVersion', 'POST', body),
    search: (versionName, appId) => query(`SELECT * from PackagedAppVersion WHERE versionName like '${versionName}' and appId =${appId} order by versionNumber desc`),
    update: (id, body) => call(`/PackagedAppVersion/${id}`, 'PUT', body),
}